import React, { useState, useEffect } from "react";
import PublishAssessBoxHW from "./PublishAssessBoxHW";
import axios from "../../../../../axios";
import NoResponse from "../../../../Pre-read/Create_Assessment_PreRead/create_successfullPreRead/NoResponse";
import moment from "moment";

let helper;
const PublishAccessBoxPropsHW = ({ filter }) => {
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [publishhw, setPublishHW] = useState([]);
  const [noresponse, setNoresponse] = useState(false);
  const [isGettingData, setIsGettingData] = useState(false);
  const [isDeactivated, setIsDeactivated] = useState(false);
  const timeHelper = (a) => {
    const outputDateString = moment(a).format("DD/MM/YYYY");
    return outputDateString;
  };

  const timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId"),
  );
  const academicSessionId = JSON.parse(
    localStorage.getItem("academicYearSessionId"),
  );
  function convertToISO(dateString) {
    const date = new Date(dateString);
    const isoDate = date.toISOString();
    return isoDate;
  }
  useEffect(() => {
    const getPublishedRes = async () => {
      setIsGettingData(true);
      try {
        helper = [];
        let response = await axios.get(
          `/api/v1/homework/filterByTeacherId/${Teacher_Json}/published?_page=1&academic_session_id=${academicSessionId}&timetable_session_id=${timeTableSessionId}` +
            `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
            `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
            `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
            `&${filter?.date && `date=${convertToISO(filter?.date)}`}` +
            `&${filter?.time && `time=${filter?.time}`}` +
            `&${
              filter?.subjectId?.length !== 0 &&
              `subjectId=${filter?.subjectId}`
            }`,
        );
        if (response?.data?.data.length === 0) {
          helper = [];
          setPublishHW([]);
          setNoresponse(true);
        }

        response?.data?.data.forEach(async (obj) => {
          let res = {
            id: obj?.id,
            section: `${obj?.section_id?.name}`,
            standard: `${obj?.standard_id?.name}`,
            published_subject: `${obj?.subject_id.name}`,
            published_assessName: `${obj?.name}`,
            deadline: timeHelper(obj?.deadline),
            Published_response: "91",
          };
          res.Published_response && helper.push(res);
          setPublishHW(helper);
        });
        setIsGettingData(false);
      } catch (error) {
        if (error.message === "No Internet Connection") {
          alert("No Internet Connection");
          return;
        }
        console.log(error);
      } finally {
        setIsGettingData(false);
      }
    };
    getPublishedRes();
  }, [filter, isDeactivated]);
  console.log(isDeactivated, "deactivated");
  console.log(publishhw);
  return publishhw && publishhw.length > 0 ? (
    <div className="container">
      <div className="row">
        {publishhw &&
          publishhw.length > 0 &&
          publishhw.map((obj) => {
            return (
              <div key={obj.id} className="col-md-3 d-flex mb-3">
                <PublishAssessBoxHW
                  id={`${obj.id}`}
                  section={`${obj?.section}`}
                  standard={`${obj?.standard}`}
                  published_subject={`${obj.published_subject}`}
                  published_assessName={`${obj.published_assessName}`}
                  deadline={`${obj.deadline}`}
                  Published_response={`${obj.Published_response}`}
                  setIsDeactivated={setIsDeactivated}
                />
              </div>
            );
          })}
      </div>
    </div>
  ) : // (
  //   <>
  //     {/* <img
  //       className="publishAccessLoader"
  //       src="/gift/black loader.gif"
  //       alt=""
  //       style={{display:"block"}}
  //     /> */}
  //     {noresponse && <NoResponse setNoresponse={setNoresponse} />}
  //     { <div style={{marginTop:"2em"}}>
  //     <h5>Homework Not Found!</h5>
  //     {/* <p>Add a new homework or check draft.</p> */}
  //     </div>}
  //   </>
  // );
  isGettingData ? (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        minHeight: "200px",
      }}
    >
      <img
        src="/gif/LoaderDot.gif"
        alt="Loading"
        style={{
          width: "100px",
          height: "110px",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)", // PERFECT CENTER
        }}
      />
    </div>
  ) : (
    <div className="d-flex justify-content-center align-items-center w-100">
      <span
        className="px-2 py-2 d-flex align-items-center gap-2"
        style={{ fontSize: "1.2rem", fontWeight: 500 }}
      >
        ✏️ Homework Not Found
      </span>
    </div>
  );
};

export default PublishAccessBoxPropsHW;
